// Local SEO landing pages — one per area served, targeting "wedding photographer <area>".
export const LOCATIONS = [
  {
    slug: "chester",
    area: "Chester",
    hero: "/jhp/natural-relaxed-chester-wedding-photographer-jason-howard-photography-101-1-2560x1333.webp",
    heroAlt: "Chester wedding photography at the Doubletree by Hilton",
    lede: "A Chester wedding photographer, born and based in the city.",
    intro:
      "I've photographed weddings across Chester for over twenty years — from the sandstone of the city walls to the region's finest country houses. As a natural, relaxed and unobtrusive photographer, my job is to let your day unfold and quietly capture it as it really felt.",
    body: [
      "Chester is one of the most beautiful places in the North West to marry, and I know its light, its venues and its hidden corners intimately. Whether you're saying your vows in the city or at a manor on its edge, you'll have a photographer who already knows exactly where the day's best moments tend to happen.",
      "Being local means I'm never rushing in from afar. I can meet for a coffee, visit your venue beforehand, and be there early on the morning without a second thought — all part of feeling like an old friend you've invited along, rather than a supplier.",
    ],
    venues: ["Rowton Hall", "Doubletree by Hilton Chester", "Willington Hall", "The Grosvenor"],
    stories: [{ label: "Tanya & Ash at Rowton Hall", to: "/gallery/rowton-hall/" }],
  },
  {
    slug: "cheshire",
    area: "Cheshire",
    hero: "/jhp/summer-wedding-cock-obarton-cheshire-jason-howard-photography-001-2560x1333.webp",
    heroAlt: "Summer Cheshire wedding photography at Cock O'Barton",
    lede: "Relaxed Cheshire wedding photography, from country houses to marquees.",
    intro:
      "Cheshire is home to some of the most sought-after wedding venues in the country, and it's where I photograph more weddings than anywhere else. My style is warm, documentary and unposed — beautiful portraits when they matter, and honest, in-between moments for everything in between.",
    body: [
      "From grand estates to intimate barn celebrations, Cheshire weddings have a character all their own. I've worked at venues right across the county and know how to make the most of their gardens, golden-hour light and grand interiors, whatever the great British weather decides to do.",
      "With over 1,600 weddings behind me, nothing fazes me on the day — which means you can relax, be present, and trust that the whole story is being told beautifully.",
    ],
    venues: ["Willington Hall", "Inglewood Manor", "Merrydale Manor", "Cock O'Barton", "Soughton Hall"],
    stories: [
      { label: "Emma & James at Willington Hall", to: "/gallery/willington-hall/" },
      { label: "Sarah & John at Inglewood Manor", to: "/gallery/inglewood-manor/" },
    ],
  },
  {
    slug: "north-wales",
    area: "North Wales",
    hero: "/jhp/natural-relaxed-wedding-jason-howard-photography-cheshire-108-2560x1333.webp",
    heroAlt: "Sunset North Wales wedding photography at Tyn Dwr Hall",
    lede: "A North Wales wedding photographer who loves its dramatic light.",
    intro:
      "From the mountains of Snowdonia to the coast of Anglesey, North Wales offers some of the most breathtaking backdrops for a wedding anywhere in the UK. I travel across the region regularly and adore the drama its landscapes bring to a couple's portraits.",
    body: [
      "Whether it's confetti on the lawn at Tyn Dwr Hall or the sweeping views at Château Rhianfa, North Wales weddings reward a photographer who knows how to work with big skies and changing light. That's exactly where I'm happiest.",
      "Being just over the border in Chester, I'm perfectly placed to cover North Wales weddings without any fuss — early starts, remote venues and destination-feel days are all part of the joy.",
    ],
    venues: ["Tyn Dwr Hall, Llangollen", "Château Rhianfa, Anglesey", "Soughton Hall"],
    stories: [
      { label: "Kelly & Gav at Tyn Dwr Hall", to: "/gallery/tyn-dwr-hall/" },
      { label: "Charlotte & Mark at Château Rhianfa", to: "/gallery/chateau-rhianfa/" },
    ],
  },
  {
    slug: "wirral",
    area: "Wirral",
    hero: "/jhp/natural-relaxed-wedding-jason-howard-photography-cheshire-102-2560x1333.webp",
    heroAlt: "Wirral wedding photography at Thornton Manor",
    lede: "Natural Wirral wedding photography at its beautiful estates.",
    intro:
      "The Wirral is home to some truly spectacular wedding venues, and I'm just a short drive away in Chester. My relaxed, unobtrusive approach suits the peninsula's mix of grand estates and coastal charm perfectly.",
    body: [
      "Thornton Manor and Inglewood Manor are among my favourite venues anywhere — elegant, generous with space, and made for the kind of honest, storytelling photography I love. I know their grounds and light well enough to make every part of your day sing.",
      "Wherever on the Wirral you're marrying, you'll have a calm, experienced photographer who blends into the background and captures the day as it truly happened.",
    ],
    venues: ["Thornton Manor", "Inglewood Manor", "Leverhulme Estate"],
    stories: [{ label: "Debbie & Liam at Thornton Manor", to: "/gallery/thornton-manor/" }],
  },
  {
    slug: "liverpool",
    area: "Liverpool",
    hero: "/jhp/natural-relaxed-wedding-photographer-cheshire-118-2560x1306.webp",
    heroAlt: "Relaxed city wedding photography for Liverpool couples",
    lede: "A relaxed wedding photographer for Liverpool couples.",
    intro:
      "Liverpool weddings have energy, character and no shortage of stunning architecture. I love the city's mix of grand rooms, waterfront light and warm, up-for-anything guests — all of which lend themselves to natural, documentary photography.",
    body: [
      "From city-centre celebrations to weddings in the countryside just beyond, I bring the same relaxed, unobtrusive approach: real moments, honest emotion, and portraits you'll actually enjoy taking.",
      "Just down the road in Chester, I'm ideally placed to photograph Liverpool weddings and everything the wider Merseyside area has to offer.",
    ],
    venues: ["City-centre venues", "The Titanic Hotel", "Countryside estates nearby"],
    stories: [],
  },
  {
    slug: "manchester",
    area: "Manchester",
    hero: "/jhp/natural-relaxed-wedding-photographer-cheshire-116-2560x1333.webp",
    heroAlt: "Relaxed Manchester wedding photography",
    lede: "Documentary wedding photography for Manchester weddings.",
    intro:
      "Manchester's weddings are as varied as the city itself — industrial-chic warehouses, elegant hotels and country escapes on its doorstep. My warm, documentary style suits them all, capturing the atmosphere and the people without ever getting in the way.",
    body: [
      "I regularly travel across Greater Manchester and the surrounding countryside, bringing two decades of experience and a calm presence to every wedding day.",
      "Whether your day is in the heart of the city or a rural retreat nearby, you'll have honest, beautifully told photographs to look back on forever.",
    ],
    venues: ["City warehouse venues", "Hotel & townhouse venues", "Cheshire estates nearby"],
    stories: [],
  },
];
